import Pill from "components/Pill"
import CommentIcon from "pages/Features/FeatureRequest/CommentIcon"
import {FeatureRequestProps, IFeatureRequest} from "pages/Features/types"
import * as R from "ramda"
import React, {useContext} from "react"
import {Box, Flex, Text, Link as ExtLink} from "ui"
import UpVote from "./UpVote"
import {toPostedAt} from "modules/helpers"
import Actions from "./Actions"
import {Link} from "@reach/router"
import LabelPill from "components/Label"
import {Label} from "Contexts/types"
import {PageContext} from "Contexts/PageContext"

export const buildPopularPill = (request: IFeatureRequest) =>
    request &&
    request.labels.length < 3 &&
    request.votes > 5 && {
        id: "popular",
        text: "Popular 🔥",
        color: "#ffb100",
        type: "PUBLIC",
    }

export const statusPill = (request: IFeatureRequest) =>
    R.cond([
        [
            R.equals("accepted"),
            () => ({
                id: "accepted",
                text: "In Progress 🎉",
                color: "#3dd598",
                type: "PUBLIC",
            }),
        ],
        [
            R.equals("completed"),
            () => ({
                id: "completed",
                text: "Completed 💎",
                color: "#ffb100",
                type: "PUBLIC",
            }),
        ],
        [
            R.equals("pending"),
            () => ({
                id: "pending",
                text: "Suggested",
                color: "#0062ff",
                type: "PUBLIC",
            }),
        ],
        [
            R.equals("rejected"),
            () => ({
                id: "rejected",
                text: "Rejected",
                color: "#fc5a5a",
                type: "PUBLIC",
            }),
        ],
        [
            R.equals("considered"),
            () => ({
                id: "considered",
                text: "In Review 🤔",
                color: "#ec5afc",
                type: "PUBLIC",
            }),
        ],
        [
            R.equals("planned"),
            () => ({
                id: "planned",
                text: "Planned",
                color: "#5afcee",
                type: "PUBLIC",
            }),
        ],

    ])(request.status)

const IntOrExtLink = ({to, children}) =>
    R.startsWith("http", to) ? (
        <ExtLink href={to} sx={{color: "inherit", textDecoration: "none"}}>
            {children}
        </ExtLink>
    ) : (
        <Link style={{color: "inherit", textDecoration: "none"}} to={to}>
            {children}
        </Link>
    )
const LinkToIf = ({to, ifTrue, children}) =>
    ifTrue ? <IntOrExtLink to={to}>{children}</IntOrExtLink> : children

const Comments = ({count}: { count: number }) => (
    <>
        <Box mr={2} p={1} bg="warningLightest" borderRadius={50}>
            <Box height="17px">
                <CommentIcon/>
            </Box>
        </Box>
        <Text ml={2} color="muted" sx={{fontWeight: "body"}} fontSize={1}>
            {count}{" "}
            <Box display={["none", "none", "inline-block"]}>{` ${
                count === 1 ? " Comment" : " Comments"
            }`}</Box>
        </Text>
    </>
)

const extraLabels = (request: IFeatureRequest, pageId: any) => {
    const popularLabel = buildPopularPill(request)
    if (pageId === "a47113d7-2ae0-4ad6-add8-34f5d9dd2ce8") {
        return popularLabel ? [popularLabel] : []
    } else {
        return [statusPill(request), ...(popularLabel ? [popularLabel] : [])]
    }
}

const FeatureRequest = ({
                            request,
                            userVoted,
                            updateUserVoted,
                            navigate,
                            showComments = true,
                            canManagePage = false,
                            showDescription = false,
                        }: FeatureRequestProps) => {
    const {page} = useContext(PageContext)

    // Isn't it beautiful
    const labels = R.pipe(
        R.propOr([], "labels"),
        R.concat(extraLabels(request, page && page.id)),
        R.map((label: Label) => (
            <Box mr={2} key={label.id} my={2}>
                <LabelPill label={label}/>
            </Box>
        ))
    )(request)
    return (
        <Flex width="100%" alignItems="center" flexWrap="wrap">
            <Flex
                mr={3}
                alignItems="center"
                justifyContent="center"
                flex="1 0 10%"
                height="100%"
            >
                <UpVote
                    userVoted={userVoted}
                    updateUserVoted={updateUserVoted}
                    request={request}
                />
            </Flex>
            <Flex flexDirection="column" flex={showComments ? "9 0 65%" : "12 0 70%"}>
                <Flex mb={2} alignItems="center" justifyContent="space-between">
                    <LinkToIf to={navigate} ifTrue={navigate}>
                        <Text width={1} fontSize={[1, 2]} sx={{fontWeight: "regular"}}>
                            {request.title}
                        </Text>
                    </LinkToIf>
                    {canManagePage && (
                        <Box display={["flex", "none"]} alignItems="center" mx={2}>
                            <Actions request={request}/>
                        </Box>
                    )}

                </Flex>
                {request.plannedDate && (
                    <Box mr={2}  my={2} style={{"width":"100px"}}>

                        <LabelPill label={{
                            text: '' + request.plannedDate,
                            id: 'x',
                            color: "#4f6df6",
                            type: "PUBLIC"
                        } }/>
                    </Box>
                        /*<Box
                                alignItems="center"
                                justifyContent="flex-start"
                                flex={["3 1 0", "3 1 10%", "3 1 17%"]}
                                display={["none", "flex"]}
                                mb={2   }
                            >
                            <Box mr={2} p={1} bg="primaryLightest" borderRadius={50}>
                                <svg  height="15px" width="20px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                    <g>
                                        <path d="m36.107 401.445c-4.143 0-7.5 3.358-7.5 7.5v83.393c0 10.842 8.82 19.662 19.662 19.662h415.458c10.844 0 19.665-8.821 19.665-19.665v-444.301c0-10.843-8.821-19.664-19.664-19.664h-23.544v-8.75c0-10.818-8.802-19.62-19.62-19.62h-6.833c-10.818 0-19.62 8.801-19.62 19.619v8.75h-34.501v-8.75c0-10.818-8.8-19.619-19.619-19.619h-6.834c-10.818 0-19.619 8.801-19.619 19.619v8.75h-34.502v-8.75c0-10.818-8.801-19.62-19.619-19.62h-6.834c-10.818 0-19.619 8.801-19.619 19.619v8.75h-34.502v-8.75c0-10.818-8.801-19.62-19.619-19.62h-6.834c-10.819.002-19.619 8.803-19.619 19.621v8.75h-34.501v-8.75c0-10.818-8.802-19.62-19.62-19.62h-6.833c-10.818 0-19.62 8.801-19.62 19.619v8.75h-23.545c-10.843 0-19.664 8.821-19.664 19.664v325.911c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-259.514h15.346c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-15.346v-51.395c0-2.572 2.093-4.664 4.664-4.664h23.544v18.956c0 10.818 8.802 19.619 19.62 19.619h6.833c10.818 0 19.62-8.801 19.62-19.619v-18.956h34.501v18.956c0 10.818 8.801 19.619 19.619 19.619h6.834c10.818 0 19.619-8.801 19.619-19.619v-18.956h34.502v18.956c0 10.818 8.801 19.619 19.619 19.619h6.834c10.818 0 19.619-8.801 19.619-19.619v-18.956h34.502v18.956c0 10.818 8.801 19.619 19.619 19.619h6.834c10.818 0 19.619-8.801 19.619-19.619v-18.956h34.501v18.956c0 10.818 8.802 19.619 19.62 19.619h6.833c10.818 0 19.62-8.801 19.62-19.619v-18.956h23.544c2.571 0 4.664 2.092 4.664 4.664v51.396h-374.438c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h374.439v377.906c0 2.572-2.093 4.665-4.665 4.665h-415.457c-2.57 0-4.662-2.091-4.662-4.662v-83.393c-.001-4.143-3.358-7.501-7.501-7.501zm66.782-339.119c0 2.547-2.072 4.619-4.62 4.619h-6.833c-2.548 0-4.62-2.072-4.62-4.619v-42.707c0-2.547 2.072-4.619 4.62-4.619h6.833c2.548 0 4.62 2.072 4.62 4.62zm80.573 0c0 2.547-2.072 4.619-4.619 4.619h-6.834c-2.547 0-4.619-2.072-4.619-4.619v-42.707c0-2.547 2.072-4.619 4.619-4.619h6.834c2.547 0 4.619 2.072 4.619 4.62zm80.574 0c0 2.547-2.072 4.619-4.619 4.619h-6.834c-2.547 0-4.619-2.072-4.619-4.619v-42.707c0-2.547 2.072-4.619 4.619-4.619h6.834c2.547 0 4.619 2.072 4.619 4.62zm80.574 0c0 2.547-2.072 4.619-4.619 4.619h-6.834c-2.547 0-4.619-2.072-4.619-4.619v-42.707c0-2.547 2.072-4.619 4.619-4.619h6.834c2.547 0 4.619 2.072 4.619 4.62zm80.575 0c0 2.547-2.072 4.619-4.62 4.619h-6.833c-2.548 0-4.62-2.072-4.62-4.619v-42.707c0-2.547 2.072-4.619 4.62-4.619h6.833c2.548 0 4.62 2.072 4.62 4.62z"/>
                                        <path d="m351.925 283.081c2.929 2.929 7.677 2.93 10.607 0l24.54-24.541c5.456-5.456 5.456-14.334 0-19.79l-31.483-31.484c-5.456-5.455-14.333-5.457-19.791 0l-104.056 104.057-55.354-55.354c-5.454-5.455-14.332-5.455-19.79 0l-31.671 31.671c-2.643 2.643-4.099 6.157-4.099 9.895s1.456 7.252 4.099 9.895l96.732 96.731c2.643 2.643 6.157 4.099 9.896 4.099 3.737 0 7.252-1.456 9.895-4.099l95.763-95.763c2.929-2.929 2.929-7.678 0-10.606-2.93-2.929-7.678-2.929-10.607 0l-95.051 95.051-95.309-95.309 30.248-30.249 59.303 59.303c1.587 1.589 3.698 2.465 5.945 2.465 2.243 0 4.353-.873 5.943-2.461l108.008-108.009 30.061 30.061-23.829 23.829c-2.929 2.93-2.929 7.679 0 10.608z"/>
                                    </g>
                                </svg>
                            </Box>
                            <Text ml={2} color="muted" sx={{fontWeight: "body"}} fontSize={1}>
                                {request.plannedDate}
                            </Text>
                            </Box>*/



                )
                }
                <Flex>
                    <Box>
                        {showComments && (
                            <LinkToIf to={navigate} ifTrue={navigate}>
                                <Box
                                    alignItems="center"
                                    justifyContent="flex-start"
                                    flex={["3 1 0", "3 1 10%", "3 1 17%"]}
                                    display={["none", "flex"]}
                                >
                                    <Comments count={request.commentCount}/>
                                </Box>
                            </LinkToIf>
                        )}

                    </Box>
                    <Box ml="auto">
                        {canManagePage && (

                            <Actions request={request}/>

                        )}

                    </Box>
                </Flex>

            </Flex>

        </Flex>
    )
}

export default FeatureRequest
